<template>
    <div>
        <template v-if="vendorPayment === null || vendorPayment === true">
            <div v-show="vendorPayment === null && history === null"><preLoader></preLoader></div>
            <div v-show="vendorPayment != null && history != null">

            <virtualAccountComponent v-if="$global.user_vr_corp == 'YES'" :paymentType="'vendor_payment'" :payroll_id="payroll_id" :payrollTotalAmount="payroll_amount"></virtualAccountComponent>
            <fincaComponent v-else-if="paymentEngine == 'FINCA' " :paymentType="'vendor_payment'" :payroll_id="payroll_id" :payrollTotalAmount="payroll_amount" :loginDetails="login_details"></fincaComponent>
            <meezanComponent v-else-if="paymentEngine == 'MEEZAN' " :paymentType="'vendor_payment'" :payroll_id="payroll_id" :payableTxnAmount="payroll_amount" :meezan_balance="meezan_balance"></meezanComponent>
            <nbpFundsComponent v-else-if="paymentEngine == 'NBP_FUND' " :paymentType="'vendor_payment'" :payroll_id="payroll_id" :payrollTotalAmount="payroll_amount" :numberOfBeneficiaries="users"></nbpFundsComponent>
            <easypaisaComponent v-else-if="paymentEngine == 'EASY_PAISA' " :paymentType="'vendor_payment'" :payroll_id="payroll_id"></easypaisaComponent>
            <faysalComponent v-else-if="paymentEngine == 'FAYSAL' " :paymentType="'vendor_payment'" :payroll_id="payroll_id"></faysalComponent>

            <div class="modal fade" id="addToArchiveDuplicatePopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Wait! Are you sure to move this batch to Archive and create a duplicate? </h2>
                            <button type="button" class="btn btn-primary addToArchiveDuplicate" @click="archiveAndDuplicate()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
                        </div>
                    </div>
                </div>
            </div>
            <!--Re upload Modal -->
            <div class="modal fade" id="reUploadBatch" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <div class="form-group mb-3">
                                <textarea v-model="reupload_comment" placeholder="Why are you reuploading this batch?" class="form-control"></textarea>
                            </div>
                            <h2 class="mt-4 mb-3"> Do you really want to reupload?  </h2>
                            <button type="button" class="btn btn-primary delete" @click="reuploadBatch()" >Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div>
            <!--Disapprove Modal -->
            <div class="modal fade" id="disapproveBatch" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <div class="form-group mb-3">
                                <textarea v-model="disapprove_comment" placeholder="Why are you disapproving this batch?" class="form-control"></textarea>
                            </div>

                            <h2 class="mt-4 mb-3"> Do you really want to disapprove?  </h2>
                            <button type="button" class="btn btn-primary delete"  @click="disapproveBatch()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="addToArchivePopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body send-to-checker-popup text-center p-4">
                        <span class="exclamation-outer">
                            <i class="fas fa-exclamation"></i>
                        </span>
                        <h2 class="mt-4 mb-3"> Wait! Are you sure to move this batch to Archive? </h2>
                        <button type="button" class="btn btn-primary addToArchive" @click="addToArchive()">Yes</button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
                    </div>
                </div>
            </div>
            </div>
            <div class="modal fade" id="sendToCheckerPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
                            <button type="button" class="btn btn-primary sendtochecker" @click="sendtochecker()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
                        </div>
                    </div>
                </div>
            </div>
            <!--Reject Batch-->
            <div class="modal fade" id="rejectBatch" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">

                            <div class="form-group mb-3">
                                <textarea v-model="reject_comment" placeholder="Why are you revising this batch?" class="form-control"></textarea>
                            </div>

                            <h2 class="mt-4 mb-3"> Do you really want to revise this batch?  </h2>
                            <button type="button" class="btn btn-primary delete" @click="rejectBatch">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="sendToApproverPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body send-to-checker-popup text-center p-4">
                        <span class="exclamation-outer">
                            <i class="fas fa-exclamation"></i>
                        </span>
                        <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
                        <button type="button" class="btn btn-primary sendtoapprover" @click="sendtoapprover()">Yes</button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
                    </div>
                </div>
            </div>
            </div>
            <div class="modal fade" id="sendToSecondApproverPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body send-to-checker-popup text-center p-4">
                        <span class="exclamation-outer">
                            <i class="fas fa-exclamation"></i>
                        </span>
                        <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
                        <button type="button" class="btn btn-primary sendtosecondapprover" @click="sendtosecondapprover()">Yes</button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
                    </div>
                </div>
            </div>
            </div>

            <!-- End Popup Code -->
            <div class="clearfix">
                <div class="page-top dropdown mb-1 mb-3 clearfix">
                    <h1 class="float-left"> {{payroll_name}} <span class="highlight-color"> ({{new Intl.NumberFormat().format(payroll_amount)}} PKR) </span> </h1>
                    <template v-if="processVendorPayment == true">
                        <button class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#loginMoblizer" v-if="((this.payrollStatus !==7 && this.payrollStatus !== 8 && this.payrollStatus !== 10 && this.payrollStatus !== 11 ) && (this.is_deleted == null && this.current_batch_approver < 2 && ((this.alreadyApproved == false && this.payrollStatus <= 3) || this.payableTxn > 0) && this.processVendorPayment == true && this.$global.user_vr_corp == 'YES' && this.$global.user_vr_balance >= this.payroll_amount && users.length > 0))"> Process </button>
                        
                        <button class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#loginMoblizer" v-if="((this.payrollStatus !==7 && this.payrollStatus !== 8 && this.payrollStatus !== 10 && this.payrollStatus !== 11 ) && (this.is_deleted == null && this.current_batch_approver < 2 && ((this.alreadyApproved == false && this.payrollStatus <= 3) || this.payableTxn > 0) && this.processVendorPayment == true && this.$global.user_vr_corp == 'NO' && this.corporateAccountBalance >= this.payroll_amount && users.length > 0))"> Process </button>
                        
                        <button class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToSecondApproverPopup" v-else-if="(this.current_batch_approver > 1 && this.is_deleted == null && this.alreadyApproved == false  && this.processVendorPayment == true && this.payrollStatus <= 3)"> Send to {{this.$global.nextApprover}} </button>
                    </template>
                    <template v-else-if="vendorPaymentSendToApprover == true">
                        <a href="#" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToChecker" @click = "sendToApproverPopup()" v-if="this.is_deleted == null && this.payrollStatus <= 2 && this.vendorPaymentSendToApprover == true  && this.alreadyChecked == false"> Send To <template v-if="this.$global.nextChecker == ''">Approver</template><template v-else>{{this.$global.nextChecker}}</template> </a>
                    </template>
                    <template v-else-if="vendorPaymentSendToChecker == true">
                        <a href="#" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToChecker" @click = "sendToCheckerPopup()" v-if="this.is_deleted == null && this.payrollStatus <= 1 && this.vendorPaymentSendToChecker == true && this.alreadyMade == false"> Send To <template v-if="this.$global.nextMaker == ''">Checker</template><template v-else>{{this.$global.nextMaker}}</template> </a>
                    </template>
                    <a href="#" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToChecker" @click = "addToArchivePopup()" v-if="this.is_deleted == null && this.archivevendor && this.payrollStatus == 11"> Add To Archive </a>
                    <a href="#" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToChecker" @click = "addToArchiveDuplicatePopup()" v-if="this.is_deleted == null && this.archiveduplicatevendor == true && this.payrollStatus == 11"> Archive and Duplicate </a>
                    <button class="btn btn-primary float-right mr-1" v-if="this.payrollStatus == 10 && paymentEngine == 'FINCA'" @click="batchStatus()" data-toggle="modal"> Batch Status </button>
                    
                    <button class="btn btn-primary float-right mr-1" v-if="this.payrollStatus == 7 && reUploadButton == true" data-toggle="dropdown" @click="reUploadPopup()"> Re-upload </button>
                    <button class="btn btn-primary float-right mr-1" v-if="this.is_deleted == null && approverRejectButton == true && this.payrollStatus <= 3" data-toggle="tooltip" data-placement="bottom" title="The batch will be sent back to checker for correction" @click="rejectPopup()"> Revise Batch </button>
                    <button class="btn btn-primary float-right mr-1" v-if="this.is_deleted == null && disapproveButton == true && this.payrollStatus <= 3" @click="disapprovePopup()" data-toggle="tooltip" data-placement="bottom" title="The batch will be cancelled completely"> Disapprove </button>
                    <!-- <button class="btn btn-primary float-right mr-1" v-if="failedArray.length > 0 && this.payrollStatus == 4" @click="showFailedModal()" data-toggle="tooltip" data-placement="bottom" title="The will only reprocess the failed transactions of this batch.">Reprocess</button> -->

                    <a href="javascript:void(0);" class="btn btn-primary float-right mr-1" v-if="this.is_deleted == null && this.deleteVendorPayment && (this.payrollStatus == 1 || this.payrollStatus == 7)" @click = "deletePayment()"> Delete Batch </a>
                    <div class="head-date float-right mr-2"> {{payroll_date}} <i class="fas fa-calendar-alt"></i> </div>
                </div>
                <!-- Start Batch Hisotry Code -->
                <div class="batch-history mb-3 clearfix">
                    <h2> <span class="text"> Batch History </span> </h2>
                    <ul class="batch-status-list">
                        <li class="status-list-item" v-for="histry in history" v-bind:value="histry.id" v-bind:key="histry.id">
                            <span class="status uploaded" v-if="histry.action == 'UPLOAD'"> Uploaded </span>
                            <span class="status flagged" v-if="histry.action == 'FLAGGED'"> Flagged
                                <!-- Show Flagged Comment -->
                                <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
                                <div class="dropdown-content">
                                    <div class="flag"> <img :src="`${$global.base_url}/images/flag.png`" alt="" /> </div>
                                    <div class="user-section mb-3">
                                        <span class="user-image">
                                        <img v-if="histry.image == null" v-bind:src="`${$global.base_url}/avatar/${histry.image}`" class="user-image" alt="">
                                        <strong class="user-image" v-if="histry.image != null">{{histry.username.substr(0,1)}}</strong>
                                        </span>
                                        <p class="">
                                        <span class="user-status user-name">{{histry.username}}</span>
                                        <span class="user-status date">{{histry.updated_at}}</span>
                                        </p>
                                    </div>
                                    <div class="text">
                                        <p> {{histry.comment}} </p>
                                    </div>
                                </div>
                                </div>
                            </span>
                            <span class="status flagged" v-if="histry.action == 'UNDERREVIEW'"> Under Review </span>
                            <span class="status uploaded" v-if="histry.action == 'REUPLOAD'"> Re-upload
                                <!-- Show Reuploaded Comment -->
                                <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
                                <div class="dropdown-content">
                                    <div class="flag"> <img src="/images/flag.png" alt="" /> </div>
                                    <div class="user-section mb-3">
                                        <span class="user-image"><img v-bind:src="'/avatar/'+histry.image" alt=""  class="user-image" /> </span>
                                        <p class="">
                                        <span class="user-status user-name">{{histry.username}}</span>
                                        <span class="user-status date">{{histry.updated_at}}</span>
                                        </p>
                                    </div>
                                    <div class="text">
                                        <p> {{histry.comment}} </p>
                                    </div>
                                </div>
                                </div>
                            </span>
                            <span class="status rejected" v-if="histry.action == 'DISAPPROVED'"> Disapproved
                                <!-- Show Disapprove Comment -->
                                <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
                                <div class="dropdown-content">
                                    <div class="flag"> <img src='/images/flag.png' alt="" /> </div>
                                    <div class="user-section mb-3">
                                        <span class="user-image"><img v-bind:src="'/avatar/'+histry.image" alt=""  class="user-image" /> </span>
                                        <p class="">
                                        <span class="user-status user-name">{{histry.username}}</span>
                                        <span class="user-status date">{{histry.updated_at}}</span>
                                        </p>
                                    </div>
                                    <div class="text">
                                        <p> {{histry.comment}} </p>
                                    </div>
                                </div>
                                </div>
                            </span>
                            <span class="status checked" v-if="histry.action == 'CHECKED'"> Checked </span>
                            <span class="status completed" v-if="histry.action == 'APPROVED'"> Approved </span>
                            <span class="status archived" v-if="histry.action == 'ARCHIVED'"> Archived </span>
                        </li>
                    </ul>
                </div>
                <!-- End Batch Hisotry Code -->
                <!-- Start Batch By Code -->
                <div class="batch-process-history mb-3">
                    <div class="batch-process-outer" v-for="bh in history" :key="bh.id" v-show="bh.action != 'UNDERREVIEW'">
                        <div class="batch-process-inner created-by"  v-if="bh.action == 'UPLOAD'">
                            <span class="action-by"> Created By </span>
                            <div class="process-content">

                                <div class="user">
                                    <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>

                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                    {{bh.designation}}
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner checked-by" v-if="bh.action == 'CHECKED'">
                            <span class="action-by"> Checked By </span>
                            <div class="process-content">
                                <div class="user">
                                    <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                        {{bh.designation}}
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner approved-by" v-if="bh.action == 'APPROVED'">
                            <span class="action-by"> Approved By </span>
                            <div class="process-content">
                                <div class="user">
                                    <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>

                            <div class="batch-process-inner disapprove-by" v-if="bh.action == 'DISAPPROVED'">
                            <span class="action-by"> Dispproved By </span>
                            <div class="process-content">
                                <div class="user">
                                    <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>

                        <div class="batch-process-inner approved-by" v-if="bh.action == 'DELETED'">
                            <span class="action-by"> Deleted By </span>
                            <div class="process-content">
                                <div class="user">
                                    <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner flagged-by" v-if="bh.action == 'FLAGGED'">
                            <span class="action-by"> Revised By </span>
                            <div class="process-content">
                                <div class="user">
                                    <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner archived-by" v-if="bh.action == 'ARCHIVED'">
                            <span class="action-by"> Archived By </span>
                            <div class="process-content">
                                <div class="user">
                                    <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner paid-by" v-if="bh.action == 'PAID'">
                            <span class="action-by"> Paid By </span>
                            <div class="process-content">
                                <div class="user">
                                    <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner reuploaded-by" v-if="bh.action == 'REUPLOAD'">
                            <span class="action-by"> Reuploaded By </span>
                            <div class="process-content">
                                <div class="user">
                                    <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                    </div>
                </div>
                <!-- End Batch By Code -->
                <!-- Start Batch Summary Code -->
                <div class="reconciliation-main mb-3" v-if="afterPayementBatchSummary == true || beforePayementBatchSummary == true">
                    <h2 class="mb-3"> Batch Summary</h2>
                    <div class="reconciliation-inner">
                        <div class="row mt-4 align-items-center">
                            <div class="col-md-3 text-right">
                                <span class="title float-none d-block p-0"> Total Payable Transactions: </span>
                            </div>
                            <div class="col-md-3"> <span class="amount d-block p-0"> {{ payableTxn }} </span> </div>
                            <div class="col-md-3 text-right">
                                <span class="text-right title float-none d-block p-0"> Total Volume: </span>
                            </div>
                            <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ payableTxnAmount | formatAmount }} </span> </div>
                        </div>                    
                        <div class="row mt-4 align-items-center" v-if="afterPayementBatchSummary == true">
                            <div class="col-md-3 text-right">
                                <span class="title float-none d-block p-0"> Successfull Transactions: </span>
                            </div>
                            <div class="col-md-3"> <span class="amount d-block p-0"> {{ successTxn }} </span> </div>
                            <div class="col-md-3 text-right">
                                <span class="title float-none d-block p-0"> Total Volume: </span>
                            </div>
                            <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ successTxnAmount | formatAmount }} </span> </div>
                        </div>
                        <div class="row mt-4 align-items-center" v-if="afterPayementBatchSummary == true">
                            <div class="col-md-3 text-right">
                                <span class="title float-none d-block p-0"> Unsuccessfull Transactions: </span>
                            </div>
                            <div class="col-md-3"> <span class="amount d-block p-0"> {{ failedTxn }} </span> </div>
                            <div class="col-md-3 text-right">
                                <span class="text-right title float-none d-block p-0"> Total Volume: </span>
                            </div>
                            <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ failedTxnAmount | formatAmount }} </span> </div>
                        </div>
                        <div class="row mt-4 align-items-center" v-if="afterPayementBatchSummary == true">
                            <div class="col-md-3 text-right">
                                <span class="title float-none d-block p-0"> Pending Transactions: </span>
                            </div>
                            <div class="col-md-3"> <span class="amount d-block p-0"> {{ pendingTxnCount }} </span> </div>
                            <div class="col-md-3 text-right">
                                <span class="text-right title float-none d-block p-0"> Total Volume: </span>
                            </div>
                            <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ pendingTxnAmount | formatAmount }} </span> </div>
                        </div>
                        <div class="row mt-4 align-items-center" v-if="afterPayementBatchSummary == true || beforePayementBatchSummary == true">
                            <div class="col-md-3 text-right">
                                <span class="title float-none d-block p-0"> Total Batch Transactions: </span>
                            </div>
                            <div class="col-md-3"> <span class="amount d-block p-0"> {{recordsTotal}} </span> </div>
                            <div class="col-md-3 text-right">
                                <span class="text-right title float-none d-block p-0"> Total Volume: </span>
                            </div>
                            <div class="col-md-3"> <span class="amount d-block p-0"> Rs. {{ payroll_amount | formatAmount }} </span> </div>
                        </div>
                        <div class="reconciliation-footer mt-4">
                            <div class="row mt-3 align-items-center mb-3" v-if="afterPayementBatchSummary == true || beforePayementBatchSummary == true ">
                                <div class="col-md-3 text-right">
                                    <span class="text-right title float-none d-block"> Total Fee: </span>
                                </div>
                              <div class="col-md-2"v-if="transationfeeSum > 0"> <span class="amount d-block"> Rs. {{parseFloat(transationfeeSum.toFixed(4))}} </span> </div>
                              <div class="col-md-2"v-if="transationfeeSum == 0"> <span class="amount d-block"> Rs. {{transationfeeSum}} </span> </div>
                              <div class="col-md-7" v-if="transationfeeSum > 0"><span class=""><small><i class="fa fa-info-circle"></i> &nbsp Charges held for “Free IBFT limit” (Rs. 25,000 per month) will be refunded in your total balance.</small></span> </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Batch Summary Code -->
            
                <div v-if="actual_status" class="alert alert-danger" role="alert">
                    <p><b> Note! </b> Please be advised that any pending transactions will be reconciled and updated on T+1 or the next business day</p>
                </div>
                <div v-if="this.$global.user_vr_corp == 'YES' && (this.payrollStatus < 4 || this.payableTxn > 0) && this.payableTxnAmount > this.$global.user_vr_balance" class="alert alert-danger" role="alert">
                    <p><b> Warning! </b> Your account has insufficient balance for this batch to process. Current Balance : {{this.$global.user_vr_balance}}</p>
                </div>
                <div v-if="this.$global.user_vr_corp == 'NO' && (this.payrollStatus < 4 || this.payableTxn > 0) && this.payableTxnAmount > this.corporateAccountBalance" class="alert alert-danger" role="alert">
                    <p><b> Warning! </b> Your account has insufficient balance for this batch to process. Current Balance : {{this.corporateAccountBalance}}</p>
                </div>
                <div class="alert alert-warning" role="alert" v-if="account_msg !== ''">
                    <p><b> Warning! </b>{{account_msg}}</p>
                </div>
                <div class="">
                    <div class="table">
                        <div class="alert alert-warning" role="alert" v-if="unRegisterWalletCount > 0">
                        <p><b> Warning! </b> Un-registered record(s) found in the batch.</p>
                        </div>
                        <div class="alert alert-danger" role="alert" v-if="failedTransactions==true">
                            <p><b> Warning! </b> There are some failed transaction(s).</p>
                        </div>
                        <!-- Start Export Button Code -->
                        <div class="btns-holder dropdown-btns clearfix mb-3" v-show="exportBatch">
                            <div class="w-15 mr-2 float-left">
                                <select class="selectpicker custom-select2" @change="batchExport($event)">
                                    <option value="">Export Batch</option>
                                    <option value="complete">Complete</option>
                                    <option value="pending">Pending</option>
                                    <option value="successfull" v-if="afterPayementBatchSummary == true && successTxn > 0">Successfull</option>
                                    <option value="failed" v-if="afterPayementBatchSummary == true && failedTxn > 0">Failed</option>
                                </select>
                            </div>
                            <div class="w-15 mr-2 float-left">
                                <select class="selectpicker custom-select2" @change="printBatch($event)">
                                    <option value="">Print Batch</option>
                                    <option value="complete">Complete</option>
                                    <option value="successfull" v-if="afterPayementBatchSummary == true && successTxn > 0">Successfull</option>
                                    <option value="failed" v-if="afterPayementBatchSummary == true && failedTxn > 0">Failed</option>
                                </select>
                            </div>
                            <a class="btn btn-primary float-left ml-1" v-if="unRegisterWalletCount > 0" @click="unRegisterWalletExport" href="javascript:void(0)"> Un-registered Record[s] </a>
                            <a class="btn btn-primary float-left ml-1" v-if="failedTransactions == true" @click="failedTransactionsExport" href="javascript:void(0)"> Failed Transactions </a>
                            <div class="filters-col m-0 float-right">
                                <input type="text" id="customSearch" class="search form-control" placeholder="Search" name="search"/>
                            </div>  
                        </div>
                        <!-- End Export Button Code -->
                        
                        <table id="viewVendorPaymentTable" class="table table-responsive-xl" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Account Title</th>
                                    <th>Category</th>
                                    <th>Fee</th>
                                    <th>Net Payable</th>
                                    <th>Purpose of Payment</th>
                                    <th v-show="flagTD == true" align="center">Flag</th>
                                    <th v-show="payTD == true || payVisible == true">Pay</th>
                                    <th>Status</th>
                                    <th v-show="downloadTD == true">Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in users" v-bind:key="user.id">
                                    <td> 
                                        <div class="image-title employe-detail-tooltip" :id="`employe-detail-tooltip-${user.id}`">
                                         {{ vendorDetails(user) }}
                                        <!-- <a href="javascript:void(0)" class="title" v-if="user.name != '' && user.name != null"> {{ user.name }} </a>
                                        <a href="javascript:void(0)" class="title" v-else> {{ user.username }} </a> -->
                                        </div>
                                    </td>
                                    <td>{{vendorAccountTitle(user.payee_vendor_beneficiary)}}</td>
                                    <td>{{user.categoryname}}</td>
                                    <td v-if="user.transactionfee > 0" >{{ parseFloat((parseFloat(user.transactionfee) + parseFloat(user.transactionfed)).toFixed(4))}}</td>
                                    <td v-else >0</td>
                                    <td>{{user.net_salary}}</td>
                                    <td>{{user.reason}}</td>
                                    <td v-show="flagTD==true">
                                        <span class="icon comment" @click="showCommentBox(user.id,user.payee_id);" :data-toggle="`popover-click${user.id}`"> <i class="far fa-comment-alt"></i> </span>
                                    </td>
    <td v-show="payTD == true || payVisible == true || user.actual_status != 'Pending'">
                                      <select v-if="!statusTD && (mca == true || (user.transfered == null && user.action != 'REJECT') && currentStatus !=10)" @change="updateRecordAction(user.id, $event)" class="form-control custom-select" name="action" id="">
                                       <option value="PAY" :selected="user.action == 'PAY'?'selected':''">Pay</option>
                                       <option value="HOLD" :selected="user.action == 'HOLD'?'selected':''">Hold</option>
                                       <option value="REJECT" :selected="user.action == 'REJECT'?'selected':''">Reject</option>
                                   </select>
                               </td>
                                    <td>
                                        <span class="status" v-if="user.transfered == 1 && user.action == 'PAY' && user.recon_status == 'NO'" style="border-color: #46a748;color: #46a748;">Paid </span>
                                        <span class="status" v-if="user.transfered == 0 && user.action == 'REJECT' && user.recon_status == 'NO'" style="border-color: #eb401f; color: #eb401f;">Reject </span>
                                        <span class="status pending" v-if="user.actual_status == 'Pending'" style="border-color: #ffc107; color: #ffc107;">Pending </span>
                                    </td>
                                    <td v-show="downloadTD == true"><a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" title="Download" class="action" @click="downloadSalarySlip(user.id)" v-if="(user.action !== 'HOLD' && user.action !== 'REJECT')" ><i class="fas fa-download"></i></a></td>
                                </tr>
                            </tbody>
                        </table>


                        <!--Display Failed transactions Modal -->
                        <!-- <div class="modal fade bd-example-modal-lg" id="displayFailed" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                <div class="modal-content">
                                    <div v-if="processVendorPayment == true" class="p-2">
                                        <div v-if="this.$global.user_vr_corp == 'YES' && (this.payrollStatus == 4 ) && this.failedSumNetSalary > this.$global.user_vr_balance" class="alert alert-danger" role="alert">
                                            <p><b> Warning! </b> Your account has insufficient balance for this batch to reprocess. Current Balance : {{this.$global.user_vr_balance}}</p>
                                        </div>
                                        <div v-if="this.$global.user_vr_corp == 'NO' && (this.payrollStatus == 4) && this.failedSumNetSalary > this.corporateAccountBalance" class="alert alert-danger" role="alert">
                                            <p><b> Warning! </b> Your account has insufficient balance for this batch to reprocess. Current Balance : {{this.corporateAccountBalance}}</p>
                                        </div>
                                        <button class="btn btn-primary float-right mr-1" data-toggle="modal" @click="showMobilizerModal" v-if="((this.payrollStatus ==4 ) && (this.$global.user_vr_corp == 'YES' && this.$global.user_vr_balance >= this.failedSumNetSalary && failedArray.length > 0))"> Reprocess </button>
                                
                                        <button class="btn btn-primary float-right mr-1" data-toggle="modal" @click="showMobilizerModal" v-if="((this.payrollStatus ==4 ) && (this.$global.user_vr_corp == 'NO' && this.corporateAccountBalance >= this.failedSumNetSalary && failedArray.length > 0))"> Reprocess </button>
                                    </div>
                                    <table id="displayFailedTable" class="table table-responsive-xl p-2" style="width:100%">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Account Title</th>
                                                <th>Category</th>
                                                <th>Fee</th>
                                                <th>Net Payable</th>
                                                <th>Purpose of Payment</th>
                                                <th>Pay</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(failed, index) in failedArray" :key="index">
                                                <td> 
                                                    <div class="image-title employe-detail-tooltip" :id="`employe-detail-tooltip1-${failed.id}`">
                                                    {{ vendorDetails(failed) }}
                                                    </div>
                                                </td>
                                                <td>{{vendorAccountTitle(failed.payee_vendor_beneficiary)}}</td>
                                                <td>{{failed.categoryname}}</td>
                                                <td>{{parseFloat(failed.transactionfee) + parseFloat(failed.transactionfed)}}</td>
                                                <td>{{(failed.net_salary)}}</td>
                                                <td>{{failed.reason}}</td>
                                                <td>Pay</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            </div>
        </template>
        <template v-else-if="vendorPayment === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var myTable = null;
    var gthat;
    import virtualAccountComponent from '../modals/virtualAccountComponent';
    import fincaComponent from '../modals/fincaComponent';
    import meezanComponent from '../modals/meezanComponent';
    import nbpFundsComponent from '../modals/nbpFundsComponent';
    import easypaisaComponent from '../modals/easypaisaComponent';
    import faysalComponent from '../modals/faysalComponent';
    export default {
        components: {
            virtualAccountComponent,
            fincaComponent,
            meezanComponent,
            nbpFundsComponent,
            easypaisaComponent,
            faysalComponent
        },
        data() {
            return {
                failedSumNetSalary:0,
                failedArray:null,
                search: null,
                payrollId : this.$route.params.id,
                recordsTotal : '',
                meezan_balance : '',
                account_status: '',
                account_msg : '',
                data : null,
                users: null,
                unRegisterWalletCount: null,
                exportBatch: false,
                failedTransactions: false,
                payroll_name:null,
                actual_status: null,
                payroll_amount:null,
                payroll_date:null,
                vendorPayment : null,
                viewvendorbatchstatus: null,
                archiveduplicatevendor: null,
                archivevendor: null,
                vendorPaymentSendToApprover: null,
                vendorPaymentSendToChecker: null,
                processVendorPayment: null,
                addVendorPayment: null,
                history:null,
                no_of_maker:null,
                no_of_checker:null,
                no_of_approver:null,
                current_batch_maker:null,
                approverRejectButton:false,
                reject_vendor_payment: null,
                batchId : null,
				disapprove_vendor_payment: null,
				vendor_hold_payment: null,
                current_batch_checker:null,
                current_batch_approver:null,
                approve_history:null,
                alreadyMade:null,
                payrollStatus : '123',
                alreadyChecked:null,
                alreadyApproved:null,
                paymentEngine: '',
                canEdit : null,
                reUploadButton: false,
                disapproveButton: false,
                deleteVendorPayment:false,
                flagTD: false,
                payTD: false,
                currentStatus:0,
                payVisible: false,
				statusTD: false,
                downloadTD: false,
                recordAction: '',
                disapprove_comment: '',
                is_deleted: '',
                payroll_id: this.$route.params.id,
                reject_comment: '',
                reupload_comment: '',
                flag_comment: '',
                row_id: 0,
                corporateAccountBalance: 0,
                form: new Form({
                    username : 'umer@finja.pk',
                    password : '',
                }),
                processForm : new Form({
                    customerName            : '',
                    iBAN                    : '',
                    balance                 : '',
                    Cookie                  : '',
                    paymentInstrumentBankAccountNumber  : '',
                    customerId              : '',
                    sessionId               : '',
                    paymentInstrumentIdSVA  : '',
                    payrollId               : this.$route.params.id,
                }),
                beforePayementBatchSummary:false,
                afterPayementBatchSummary:false,
                successTxn:null,
                pendingTxnCount: 0,
                pendingTxnAmount: 0,
                successTxnAmount:null,
                failedTxn:null,
                failedTxnAmount:null,
                transationfeeSum:0,
                payableTxn: null,
                payableTxnAmount:0,
                mca:false,
                payroll_frequency:null,
                login_details:null,
            };
        },
        mounted() {
    
            this.$Progress.start();
            var permissions=false; 
            this.can('vendor_delete_batch|vendor_hold_payment|disapprove_vendor_payment|reject_vendor_payment|view_vendor_batch_status|archive_vendor_payment_create_new|archive_vendor_payment|vendor_payment_send_to_approver|vendor_payment_send_to_checker|process_vendor_payment|add_vendor_payment|vendor_payments').then(result => {
              //   this.vendorPayment = result.vendorPayments;
                this.deleteVendorPayment = result.vendor_delete_batch;
                this.viewvendorbatchstatus = result.view_vendor_batch_status;
                this.archiveduplicatevendor = result.archive_vendor_payment_create_new;
                this.archivevendor = result.archive_vendor_payment;
                this.vendorPaymentSendToChecker = result.vendor_payment_send_to_checker;
                this.vendorPaymentSendToApprover = result.vendor_payment_send_to_approver;
                this.processVendorPayment = result.process_vendor_payment;
                this.addVendorPayment = result.add_vendor_payment;
                permissions = result.vendor_payments;
                this.vendor_hold_payment = result.vendor_hold_payment;
                this.disapprove_vendor_payment = result.disapprove_vendor_payment;
                this.reject_vendor_payment = result.reject_vendor_payment;
                if(permissions){
                   this.getCorporateCompanyBalance();
                    $('.selectpicker').selectpicker('refresh');
                    // this.getVendorPaymentList();
                    this.viewVendorPaymentSheet();
                    // this.getFailedTransactions();
                    // this.getPaymentEngineData();
                    if(this.reject_vendor_payment == true){
                        this.approverRejectButton=true;
                    }
                    if(this.disapprove_vendor_payment == true){
                        this.disapproveButton=true;
                    }
                }
                //if(this.$global.user_vr_corp == 'YES'){
                    //swal.fire({
                        //type: 'info',
                        //title: "Hi, finja business is undergoing a maintenance patch. You will be notified as soon as your batch will be processed"
                    //});
                //}
                this.$Progress.finish();
            }).then(result => {
                
            });
            // var that = this;
            // $(document).ready(function(){
            //     window.updateRecordAction = function(recordId,status){
            //         that.updateRecordAction(recordId,status);
            //     }
            // })
        },
        watch : {
            failedArray(){
                this.failedArray.forEach(val => {
                    this.failedSumNetSalary += val.net_salary;
                });
            }
        },
        methods: {
            
            showMobilizerModal(){
                // EventBus.$emit('paymentReprocess', true);
                $('#displayFailed').modal('hide');
                $('#loginMoblizer').modal('show');
            },
            getFailedTransactions(){
                axios.post('/api/getFailedVendorBatch/'+ this.$route.params.id, {
                    batchType: 'failed' })
                .then((response) => {
                    if(response.status == 200){
                        this.failedArray = response.data;
                    }else{
                        this.showAlertBox('error','There is some problem');
                    }
                }).then((response)=>{
                    $('#displayFailedTable').DataTable({
                        "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                        "searching":true,
                        columnDefs: [ {
                            orderable: false,
                            targets:   1
                        }],
                        order: [[ 1, "desc" ]],
                        drawCallback: function() {

                        }
                    });
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },
            showFailedModal(){
                $('#displayFailed').modal('show');
            },
            
            vendorAccountTitle(beneficiary){
                if(beneficiary !== null){
                    return beneficiary.account_title;
                }
            },

            vendorDetails(user){
                var that = this;
                if(user.payee_vendor_beneficiary !== null){
                    var title = '<div >' +
                        '<p class="custom-tooltip-content">' +
                        '<span class="tooltip-col tooltip-title"> Account Type : </span>' +
                        '<span class="tooltip-col">'+user.payee_vendor_beneficiary.account_type+'</span>' +
                        '</p>' +
                        '<p class="custom-tooltip-content">' +
                        '<span class="tooltip-col tooltip-title"> Bank : </span>' +
                        '<span class="tooltip-col">'+user.payee_vendor_beneficiary.bank_name+'</span>' +
                        '</p>' +
                        '<p class="custom-tooltip-content">' +
                        '<span class="tooltip-col tooltip-title"> Account Number : </span>' +
                        '<span class="tooltip-col">'+user.payee_vendor_beneficiary.account_number+'</span>' +
                        '</p>' +
                        '<p class="custom-tooltip-content">' +
                        '<span class="tooltip-col tooltip-title"> CNIC/NTN : </span>' +
                        '<span class="tooltip-col">'+that.vendorCnic(user.vendor)+'</span>' +
                        '</p>' +
                        '<p class="custom-tooltip-content">' +
                        '<span class="tooltip-col tooltip-title"> Cell # : </span>' +
                        '<span class="tooltip-col">'+user.mobileNo+'</span>' +
                        '</p>' +
                        '</div>';
                    }else{
                        var title = '';
                    }
                setTimeout(function(){
                    $("#employe-detail-tooltip-"+user.id).tooltip({
                        title:title,
                        html: true,
                        placement: 'right',
                        offset: '40',
                        template: '<div class="tooltip custom-tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
                    });
                },100);
                return user.name;
                
            },
            // searchFilter(e){
            //     if (e.keyCode === 13) {
            //         this.$Progress.start();
            //         myTable.draw();  
            //     }
            // },
            rejectPopup(){
                $('#rejectBatch').modal('show');
            },
            disapprovePopup(){
                $('#disapproveBatch').modal('show');
            },
            reUploadPopup(){
               $('#reUploadBatch').modal('show');
            },
            unRegisterWalletExport: function () {
                this.$Progress.start();
                axios.post('/api/unRegisterWalletExportVendor', {
                    id : this.payrollId,
                    batchId : this.batchId,
                },{
                    responseType: 'blob'
                }).then(res => {
                    if(res.status == 200){
                        const url = URL.createObjectURL(new Blob([res.data], {
                            type: 'application/vnd.ms-excel'
                        }))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'VendorBatchUnRegisteredWallet.csv')
                        document.body.appendChild(link)
                        link.click();
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            failedTransactionsExport: function () {
                this.$Progress.start();
                axios.post('/api/vendorFailedTransactionsExport', {
                    id : this.payrollId },{
                    responseType: 'blob'
                }).then(res => {
                    if(res.status == 200){
                        const url = URL.createObjectURL(new Blob([res.data], {
                            type: 'application/vnd.ms-excel'
                        }))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'VendorBatchFailed.csv')
                        document.body.appendChild(link)
                        link.click()
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                }).catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                });
            },
            batchExport: function (e) {
                var param = e.target.value;
                if(param !== ""){
                    this.$Progress.start();
                    axios.post('/api/vendorBatchExport', {
                        id : this.payrollId, batchType: param },{
                        responseType: 'blob'
                    }).then(res => {
                            if(res.status == 200){
                                    const url = URL.createObjectURL(new Blob([res.data], {
                                    type: 'application/vnd.ms-excel'
                                }))
                                const link = document.createElement('a')
                                link.href = url
                                link.setAttribute('download', 'VendorBatchList.csv')
                                document.body.appendChild(link)
                                link.click()
                                this.$Progress.finish();
                            }else{
                                this.$Progress.fail();
                            }
                        })
                        .catch(err => {
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        });
                }
            },
            printBatch: function (e) {
                var param = e.target.value;
                if(param !== ""){
                    axios.post('/api/printVendorBatch/'+ this.$route.params.id, {
                        batchType: param })
                    .then((response) => {
                        if(response.status == 200){
                            var mywindow = window.open('', 'PRINT', 'height=400,width=600');
                            mywindow.document.write(response.data);
                            mywindow.document.close(); // necessary for IE >= 10
                            mywindow.focus(); // necessary for IE >= 10*/
                            mywindow.print();
                            // mywindow.close();
                            return true;
                        }else{
                            this.showAlertBox('error','There is some problem');
                        }
                    }).catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    });
                }
            },
            batchStatus(){
				var payroll_id = this.payroll_id;
				this.$Progress.start();
                axios.post('/api/batchStatusVendor',{
					payroll_id: payroll_id
				})
                .then(res => {
                    if(res.status == 200){
						this.$Progress.finish();
						if(res.data.code == 403){
							this.showToastBox('info',res.data.data);
						}else if(res.data.code == 200){
                            this.showToastBox('success',res.data.data);
                        }
                         this.$router.push('/vendorPayment');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },
            rejectBatch(){
                var payroll_id = this.payrollId;
                var comment = this.reject_comment;
                this.$Progress.start();
                $('#rejectBatch').modal('hide');
                axios.post('/api/rejectPayrollVendor',{
                    payroll_id: payroll_id,
                    comment: comment
                }).then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Batch successfully revised');
                        this.$router.push('/vendorPayment');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },
            disapproveBatch(){
                var payroll_id = this.payrollId;
                var comment = this.disapprove_comment;
				this.$Progress.start();
                $('#disapproveBatch').modal('hide');
                axios.post('/api/disapproveBatchVendor',{
                    payroll_id: payroll_id,
                    comment:comment
				}).then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Batch successfully disapproved'
                        });
                        this.$router.push('/vendorPayment');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
			},
            reuploadBatch(){
				var payroll_id = this.payrollId;
				var reupload_comment = this.reupload_comment;
				this.$Progress.start();
                $('#reUploadBatch').modal('hide');
                axios.post('/api/reuploadBatchVendor',{
					payroll_id: payroll_id,
                    comment: reupload_comment
				}).then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.$router.push('/vendorPaymentBulkUpload?payroll_id='+payroll_id);
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','There is some problem');
                    }

                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
			},
            // getPaymentEngineData: function(){
            //     this.$Progress.start();
            //     axios.post("/api/getPaymentEngine")
            //         .then(res => {
            //             if(res.status == 200){
            //                 this.paymentEngine = res.data.data;
            //                 this.$Progress.finish();
            //             }else{
            //                 this.$Progress.fail();
            //                 this.showAlertBox('error','Error to load form data');
            //             }
            //         })
            //         .catch(err => {
            //             this.$Progress.fail();
            //             this.showAlertBox('error','Error to load form data');
            //         });
            // },
            archiveAndDuplicate : function(){
                $('.addToArchiveDuplicate').prop('disabled',true);
                axios.get('/api/vendorPaymentArchiveAndDuplicate/'+this.$route.params.id, {})
                    .then(res => {
                        if(res.data.status == 200){
                            this.showToastBox('success','Your batch is Archived and created duplicate.');
                            this.getVendorPaymentData();
                            $('#addToArchiveDuplicatePopup').modal('hide');
                        }else{
                            this.showAlertBox('error',res.data.msg);
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            addToArchive : function(){
                $('.addToArchive').prop('disabled',true);
                axios.get('/api/vendorPaymentArchive/'+this.$route.params.id, {})
                    .then(res => {
                        if(res.data.status == 200){
                            this.showToastBox('success','Your batch is archived.');
                            this.getVendorPaymentData();
                            $('#addToArchivePopup').modal('hide');
                        }else{
                            this.showAlertBox('error',res.data.msg);
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            processVendorPayments: function(){
                this.$Progress.start();
                this.processForm.post('/api/VendorSendForPayment')
                    .then(res => {
                        if(res.status == 200){
                            $('#loginMoblizer').modal('hide');
                            $('#dt-new').DataTable().ajax.reload();
                            this.$Progress.finish();
                            this.showToastBox('success',res.data.message);
                            this.$router.push('/vendorPayment');
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Fail to fetch data')
                        }

                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            cancelMobilizer: function(){
                $('#loginMoblizer').find('.moblizer-account-login').removeClass('hide');
                $('#loginMoblizer').find('.moblizer-account-detail').addClass('hide');
            },
            proceedPayroll: function(){
                if(this.form.username == '' || this.form.password == ''){
                    this.showToastBox('error','Please enter the credentials!');
                    return;
                }
                this.$Progress.start();
                this.form.post('/api/vendorCorpLogin')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            if (res.data.status == '200'){
                                this.processForm.customerName = res.data.data.customerName;
                                this.processForm.iBAN = res.data.data.IBAN;
                                this.processForm.paymentInstrumentBankAccountNumber = res.data.data.paymentInstrumentBankAccountNumber;
                                this.processForm.balance = res.data.data.balance;
                                this.processForm.customerId = res.data.data.customerId;
                                this.processForm.Cookie = res.data.data.Cookie;
                                this.processForm.paymentInstrumentIdSVA = res.data.data.paymentInstrumentIdSVA;
                                this.processForm.sessionId = res.data.data.sessionId;
                                $('#loginMoblizer').find('.moblizer-account-login').addClass('hide');
                                $('#loginMoblizer').find('.moblizer-account-detail').removeClass('hide');
                            }else{
                                this.showAlertBox('error',res.data.msg);
                            }
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Fail to fetch data')
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },
            addToArchivePopup(){
                $('.addToArchive').prop('disabled',false);
                $('#addToArchivePopup').modal('show');
            },
            addToArchiveDuplicatePopup(){
                $('.addToArchiveDuplicate').prop('disabled',false);
                $('#addToArchiveDuplicatePopup').modal('show');
            },
            sendToCheckerPopup(){
                $('.sendtochecker').prop('disabled',false);
                $('#sendToCheckerPopup').modal('show');
            },
            sendToApproverPopup(){
                $('.sendtoapprover').prop('disabled',false);
                $('#sendToApproverPopup').modal('show');
            },
            sendToSecondApproverPopup(){
                $('.sendtoapprover').prop('disabled',false);
                $('#sendToSecondApproverPopup').modal('show');
            },
            viewVendorPaymentSheet: function(){
                var that = this;
                axios.get('/api/viewVendorPaymentSheet/'+this.$route.params.id).then(response => {
                    if(response.status == 200){
                        var response = response.data;
                        this.actual_status = response.actual_status;
                        this.login_details = response.login_details;
                        that.users = response.records;
                        //for meezan case
                        this.meezan_balance = response.meezan_balance;
                        this.paymentEngine = response.payment_engine;
                        this.account_status = response.account_status;
                        if(this.account_status !== '' || this.account_status !== null){
                            if(this.account_status.status == 400){
                                this.account_msg = this.account_status.msg;
                            }
                        }

                        that.payroll_name = response.payrolllist.name;
                        that.is_deleted = response.payrolllist.deleted_at;
                        that.payrollStatus = response.payrolllist.status;
                        that.current_batch_maker = response.payrolllist.no_of_maker;
                        that.current_batch_checker = response.payrolllist.no_of_checker;
                        that.current_batch_approver = response.payrolllist.no_of_approver;
                        that.payroll_amount = response.payrolllist.payroll_amount;
                        that.batchId = response.batchId;
                        that.canEdit = response.payrolllist.canEdit;
                        that.approve_history = response.approve_history;
                        that.unRegisterWalletCount = response.unregisterWallet;
                        that.alreadyMade = response.alreadyMade;
                        that.alreadyChecked = response.alreadyChecked;
                        that.alreadyApproved = response.alreadyApproved;
                        that.no_of_maker = response.company.no_of_maker;
                        that.no_of_checker = response.company.no_of_checker;
                        that.no_of_approver = response.company.no_of_approver;

                        that.successTxn = response.successTxn;
                        that.successTxnAmount = response.successTxnAmount;
                        that.pendingTxnCount = response.pendingTxnCount;
                        that.pendingTxnAmount = response.pendingTxnAmount;
                        that.failedTxn = response.failedTxn;
                        that.failedTxnAmount = response.failedTxnAmount;
                        that.transationfeeSum = response.transationfeeSum;
                        that.payableTxn = response.payableTxn;
                        that.payableTxnAmount = response.payableTxnAmount;
                        that.recordsTotal = response.recordsTotal;

                        that.exportBatch = true;
                        that.payroll_frequency = response.payrolllist.payroll_frequency;

                        if(response.payrolllist.payroll_frequency == 'ONETIME'){
                            that.payroll_date = response.payrolllist.from_date;
                        }else{
                            that.payroll_date = response.payrolllist.from_date+"-"+response.payrolllist.to_date;
                        }
                        var status = response.payrolllist.status;
                        if(status == 1 || status == 2 || status == 3 || status == 7 || status == 8){
                            this.beforePayementBatchSummary = true;
                        }
                        if(status == 4 || status == 5 || status == 11 || status == 10){
                            this.afterPayementBatchSummary = true;
                        }
                        if(status == 1 || status == 2 || status == 3 ){
                            that.mca = true;
                        }
                                
                        if(status != 4 && status != 5){
                            if(that.addVendorPayment == true){
                                if(status == 7 || status == 6){
                                    that.flagTD = true;
                                }
                            }
                            if(that.vendorPaymentSendToApprover || that.processVendorPayment){
                                that.flagTD = true;
                            }
                        }
                        if(that.vendor_hold_payment && status !=10){
                            this.payTD = true;
                            that.payVisible = true;
                        }else{
                            this.payTD = true;
                            that.payVisible = true;
                        }

                        if( that.addVendorPayment == true && status == 7){ // flagged
                            that.reUploadButton = true;
                        }
                        if(status == 4 || status == 5){
                            that.statusTD = true;
                            that.downloadTD = true;
                        }

                        that.history = response.history;
                    }else{
                        this.$Progress.fail();
                    }
                }).then(response => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    myTable = $('#viewVendorPaymentTable').DataTable({
                        "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                        "searching":true,
                        columnDefs: [ {
                            orderable: false,
                            targets:   1
                        }],
                        order: [[ 1, "desc" ]],
                        drawCallback: function() {

                        }
                        });
                    $('#customSearch').on( 'keyup', function (e) {
                        if (e.keyCode === 13) {
                            myTable.search( this.value ).draw();
                        }
                    });
                });
            },
            showCommentBox: function(id,userid){
                let that = this;
                that.row_id = userid;
                axios.post("/api/vendorBatchComment",{
                    id: id,
                }).then(res => {
                    if(res.status == 200){
                        if($("#commentData").length !=0){
                            $('#commentData').html(res.data.data);
                            $('#commentText').val('');
                        }

                        var flagComment = '<div class="flag-comment-box clearfix">'+
                                    '<div id="commentData">' + res.data.data + '</div>' +
                            '<div class="main-textbox mb-3"><textarea class="form-control" id="commentText"></textarea></div>' +
                                    '<button class="btn btn-primary float-right" onclick="VueComponents.viewVendorPaymentSheetComponent.methods.addComment('+id+')"> Submit </button>' +
                            '</div>';
                        $('[data-toggle="popover-click'+id+'"]').popover({
                            html: true,
                            placement: 'right',
                            sanitize: false,
                            content: flagComment,
                            template: '<div class="popover flaged-comment" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>'
                        }).popover('show');

                        $(document).on( 'keyup', '#commentText',function () {
                            that.flag_comment = this.value;
                        });
                        $(document).mouseup(function(e)
                        {
                            var container = $('.popover');
                            if (!container.is(e.target) && container.has(e.target).length === 0)
                            {
                                $('.comment').popover('dispose');
                            }
                        });
                    }else{
                        //that.$Progress.fail();
                        that.showAlertBox('error','Error to load form data');
                    }
                }).catch(err => {
                    //that.$Progress.fail();
                    that.showAlertBox('error','Error to load form data');
                });
            },
            vendorCnic(vendor){
                if(vendor !== null){
                    return vendor['cnic'];
                }else{
                    return '---';
                }
            },
           
            downloadSalarySlip: function(id){
                axios.get('/api/downloadVendorPaymentSlip/'+id, {responseType: 'arraybuffer'})
                .then((response) => {
                    if(response.status == 200 || response.status == 204){
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = 'Payment Slip.pdf'
                        link.click();
                        this.showToastBox('success','File downloaded successfully');
                    }else{
                        this.showAlertBox('error','Something went wrong, Please try again');
                    }

                });
            },
            updateRecordAction(recordId, e){
                var that = this;
                that.recordAction = e.target.value;
                var obj = {
                    action: that.recordAction,
                    sheetStatus: that.payrollStatus,
                    recordId: recordId,
                    payrollId : that.payrollId
                }
                that.$Progress.start();
                axios.post("/api/updateRecordActionVendor", obj)
                    .then(res => {
                        if(res.status == 200){
                            that.payableTxn = res.data.data.totalPayableCount;
                            that.payableTxnAmount = res.data.data.totalPayableAmount;
                            that.$Progress.finish();
                        }else{
                            that.$Progress.fail();
                            that.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        that.showAlertBox('error','Error to load form data');
                        that.$Progress.fail();
                    });
            },
            addComment: function(id){
                var that = this;
                // var id = id;
                // if(that.flag_comment == ''){
                //     return false;
                // }
                window.payrollPlusApp.$Progress.start();
                that.flag_comment = $('#commentText').val();
                console.log(that.flag_comment);

                if(that.flag_comment == '' || that.flag_comment.length == 0){
                    window.payrollPlusApp.showToastBox('warning','Please enter comment');
                    window.payrollPlusApp.$Progress.finish();
                    return;
                }

                axios.post("/api/addVendorBatchComment",{
                    id: id,
                    flag_comment: that.flag_comment,
                })
                    .then(res => {
                        if(res.status == 200){
                            //that.$Progress.finish();
                            $('#commentData').html(res.data.data);
                            $('#commentText').val('');
                            that.flag_comment = '';
                            //this.getUserData(id);
                            /*$('[data-toggle="popover"]').popover();*/
                        }else{
                            //that.$Progress.fail();
                            that.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        //that.$Progress.fail();
                        that.showAlertBox('error','Error to load form data');
                    });
            },

            getVendorPaymentData(){
                axios.get('/api/vendorPaymentData/'+this.$route.params.id, {
                })
                    .then(res => {

                        if(res.status == 200){
                            this.payroll_name = res.data.payrolllist.name;
                            this.payrollStatus = res.data.payrolllist.status;
                            this.current_batch_maker = res.data.payrolllist.no_of_maker;
                            this.current_batch_checker = res.data.payrolllist.no_of_checker;
                            this.current_batch_approver = res.data.payrolllist.no_of_approver;
                            this.payroll_amount = res.data.payrolllist.payroll_amount;
                            this.canEdit = res.data.payrolllist.canEdit;
                            this.approve_history = res.data.approve_history;
                            this.alreadyMade = res.data.alreadyMade;
                            this.alreadyChecked = res.data.alreadyChecked;
                            this.alreadyApproved = res.data.alreadyApproved;
                            this.no_of_maker = res.data.company.no_of_maker;
                            this.no_of_checker = res.data.company.no_of_checker;
                            this.no_of_approver = res.data.company.no_of_approver;
                            if(res.data.payrolllist.payroll_frequency == 'ONETIME'){
                                this.payroll_date = res.data.payrolllist.from_date;
                            }else{
                                this.payroll_date = res.data.payrolllist.from_date+"-"+res.data.payrolllist.to_date;
                            }
                            this.history = res.data.history;
                        }
                            //this.viewVendorPaymentSheet();
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load data'
                        });
                    });
            },
            getVendorPaymentList(){
                var that = this;
                axios.get('/api/vendorPaymentList/'+this.$route.params.id, {
                })
                    .then(response => {
                        if(response.status == 200){

                            response = response.data;
                            this.meezan_balance = response.meezan_balance;
                            this.paymentEngine = response.payment_engine;
                            this.account_status = response.account_status;
                            if(this.account_status !== '' || this.account_status !== null){
                                if(this.account_status.status == 400){
                                    this.account_msg = this.account_status.msg;
                                }
                            }
                            if(response.payrolllist == null){
                                this.vendorPayment = false;
                            }else{
                                var status = response.payrolllist.status;
                                that.currentStatus = status;

                                if(status == 1 || status == 2 || status == 3 || status == 7 || status == 8){
                                    this.beforePayementBatchSummary = true;
                                }
                                if(status == 4 || status == 5 || status == 11){
                                    this.afterPayementBatchSummary = true;
                                }
                                if(response.payrolllist.status != 4 && response.payrolllist.status != 5){
                                    if(that.addVendorPayment == true){
                                        if(response.payrolllist.status == 7 || response.payrolllist.status == 6){
                                            that.flagTD = true;
                                        }
                                    }
                                    if(that.vendorPaymentSendToApprover || that.processVendorPayment){
                                        that.flagTD = true;
                                    }
                                }
                                if(this.vendor_hold_payment && status !=10){
                                    this.payTD = true;
                                    that.payVisible = true;
                                }else{
                                    this.payTD = true;
                                    that.payVisible = true;
                                }
                            if(status == 1 || status == 2 || status == 3 ){
                                that.mca = true;
                            }
                                    
                            // if((that.processVendorPayment && response.payrolllist.status <= 3) || (that.processVendorPayment && response.payrolllist.status === 4 && response.holdCount > 0)){
                            //     that.payTD = true;
                            // }
                            if(response.payrolllist.status == 4 || response.payrolllist.status == 5){
                                that.statusTD = true;
                                that.downloadTD = true;
                            }
                            
                        }
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            sendtochecker : function(){
                $('.sendtochecker').prop('disabled',true);
                    axios.get('/api/vendorPaymentSendToChecker/'+this.$route.params.id, {})
                    .then(res => {
                        if(res.data.status == 200){
                            if(this.$global.nextMaker == ''){
                                this.showToastBox('success','You batch is sent to checker successfully');
                            }else{
                                this.showToastBox('success','You batch is sent to '+this.$global.nextmaker+' successfully');
                            }
                            this.getVendorPaymentData();
                            $('#sendToCheckerPopup').modal('hide');
                        }else{
                            this.showAlertBox('error',res.data.msg);
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            deletePayment(){

                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    this.$Progress.start();
                    if (result.value) {
                        axios.get('/api/deleteVendorPayment/'+this.$route.params.id, {})
                        .then(res => {
                            if(res.status == 200){
                                if(res.data.code == 200){
                                    this.showToastBox('success','Your batch is deleted successfully');
                                    this.$router.push('/vendorPayment');
                                }else{
                                    this.showAlertBox('error','Error in deleteing your batch.');
                                }
                            }else{
                                this.showAlertBox('error','Error in deleting your batch');
                            }
                        })
                        .catch(err => {
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load data');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        this.$Progress.fail();
                        this.showAlertBox('error','Your decision has been cancelled');
                    }
                })
            },
            sendtoapprover(){
                $('.sendtoapprover').prop('disabled',true);
                axios.get('/api/vendorPaymentSendToApprover/'+this.$route.params.id, {})
                    .then(res => {
                        if(res.data.status == 200){
                            if(this.$global.nextChecker == ''){
                                this.showToastBox('success','Your batch is sent to approver successfully');
                            }else{
                                this.showToastBox('success','Your batch is sent to '+this.$global.nextChecker+' successfully');
                            }
                            this.getVendorPaymentData();
                            $('#sendToApproverPopup').modal('hide');
                        }else{
                            this.showAlertBox('error',res.data.msg);
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            sendtosecondapprover(){
                $('.sendtosecondapprover').prop('disabled',true);
                axios.get('/api/vendorPaymentSendToSecondApprover/'+this.$route.params.id, {})
                    .then(res => {
                        if(res.data.status == 200){
                            this.showToastBox('success','Your batch is approved successfully');
                            this.getVendorPaymentData();
                            $('#sendToSecondApproverPopup').modal('hide');
                        }else{
                            this.showAlertBox('error',res.data.msg);
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },

            getCorporateCompanyBalance: function(){
                this.$Progress.start();
                axios.get("/api/getCurrentBalanceData")
                    .then(res => {
                        if(res.status == 200){                            
                            this.corporateAccountBalance = res.data.data.balance;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to fetch balance !');
                        }
                      this.vendorPayment = true;
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to fetch balance !');
                    });
            },








            /*sendtoapprovery : function(){
               const swalWithBootstrapButtons = Swal.mixin({})
                swalWithBootstrapButtons.fire({
                title: 'Are you sure?',
                text: "Double checks are always great! Do you want to check again or proceed?",
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: "No, cancel it!",
                confirmButtonText: "Yes, Send it!",
                reverseButtons: true
                }).then((result) => {
                if (result.value) {
                    this.sentToApproverAction();
                } else if (
                    /!* Read more about handling dismissals below *!/
                    result.dismiss === Swal.DismissReason.cancel
                ) {
                    swalWithBootstrapButtons.fire(
                    'Cancelled',
                    'You cancel the Batch for re-verification',
                    'error'
                    )
                }
                })
            },
            sentToApproverAction(){
                axios.post('/api/sendForApprover/',{payrollId : this.payrollId})
                .then(res => {
                    if(res.status == 200){
                        toast.fire({
                                type: 'success',
                                title: 'Your Batch sent to Approver successfully.',
                                });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load form data'
                        });
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load form data'
                    });
                });
            },*/
        },
    }
</script>
